export enum BACKGROUND_OPERATION_STATUS {
  RUNNING = "RUNNING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  CANCEL_REQUESTED = "CANCEL_REQUESTED",
  CANCELLED = "CANCELLED",
  UNKNOWN = "UNKNOWN",
}

export enum BACKGROUND_OPERATION_MODE {
  EPHEMERAL_JOB = "EPHEMERAL_JOB",
  IN_PROCESS = "IN_PROCESS",
}

export interface IBackgroundOperationMetadata {
  route_id?: string;
  action_right?: string;
  job_id?: string;
  workflow_id?: string;
  workflow_name?: string;
  workflow_report_id?: string;
  workflow_report_name?: string;
  workflow_report_status?: string;
  step_id?: string;
  step_name?: string;
}

export interface IBackgroundOperation {
  id: string;
  client_id: string;
  operation_type: string;
  execution_mode: BACKGROUND_OPERATION_MODE;
  status: BACKGROUND_OPERATION_STATUS;
  created_at: string;
  action_code?: string;
  triggered_by_email?: string;
  k8s_job_name?: string;
  started_at?: string;
  ended_at?: string;
  duration_ms?: number;
  error_message?: string;
  metadata?: IBackgroundOperationMetadata;
}

/**
 * Payload attached by the backend to the RUN_IN_BACKGROUND business error.
 */
export interface IStartedBackgroundOperation {
  operation_id: string;
  operation_type: string;
}

const ONGOING_STATUSES = [
  BACKGROUND_OPERATION_STATUS.RUNNING,
  BACKGROUND_OPERATION_STATUS.CANCEL_REQUESTED,
];

export const isOperationOngoing = (operation: IBackgroundOperation): boolean =>
  ONGOING_STATUSES.includes(operation.status);

export const isOperationCancellable = (
  operation: IBackgroundOperation,
): boolean => operation.status === BACKGROUND_OPERATION_STATUS.RUNNING;
